<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">그룹레슨 관리</span>
            <span class="txt">그룹레슨을 생성등록, 수정, 삭제가 가능합니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <select-form
                    :select-data="['강사명', ...teacherList]"
                    :select-value="['', ...teacherValueList]"
                    :selected-value="searchTeacherStaff"
                    @update:set="(val) => (searchTeacherStaff = val)"
                ></select-form>
                <select-form
                    :select-data="['전체', '진행중', '종료됨']"
                    :select-value="['', 'true', 'false']"
                    :selected-value="progress"
                    @update:set="(val) => (progress = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchParams"></button>
                <div class="com-search-input">
                    <input v-model="searchStr" placeholder="프로그램 명" type="text" v-on:keyup.enter="onEventSearch" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <span class="txt">
                        총
                        <span class="blue">{{ totalItems }}</span>
                        건
                    </span>
                    &nbsp;&nbsp;&nbsp;
                    <button class="com-btn blue" @click="groupLessonReg">그룹레슨 등록</button>
                    <button class="com-btn" @click="groupLessonBatchModify">일괄 수정</button>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 60px" />
                    <col style="width: 70px" />
                    <col style="width: 70px" />
                    <col style="width: 180px" />
                    <col style="width: 70px" />
                    <col style="width: 70px" />
                    <col style="width: 70px" />
                    <col style="width: 180px" />
                    <col style="width: 70px" />
                    <col style="width: 70px" />
                    <col style="width: 70px" />
                    <col style="width: 240px" />
                    <col style="width: 150px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <div class="com-check">
                                <input
                                    id="check-1-1"
                                    v-model="selectAll"
                                    name="check-1"
                                    type="checkbox"
                                    @change="allCheckBox"
                                />
                                <label for="check-1-1"></label>
                            </div>
                        </th>
                        <th>상태</th>
                        <th>강사명</th>
                        <th>수업기간</th>
                        <th>수업요일</th>
                        <th>시작시간</th>
                        <th>진행시간</th>
                        <th>프로그램명</th>
                        <th>수업인원</th>
                        <th>대기인원</th>
                        <th>등록일자</th>
                        <th>센터명</th>
                        <th>관리</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(g, index) in groupLessonList" :key="index">
                        <td>
                            <div class="com-check">
                                <input
                                    :id="`check-1-1-${g.clsm_center_less_schd_master_id}`"
                                    v-model="checkLessonList"
                                    :value="g.clsm_center_less_schd_master_id"
                                    name="check-1"
                                    type="checkbox"
                                />
                                <label :for="`check-1-1-${g.clsm_center_less_schd_master_id}`"></label>
                            </div>
                        </td>
                        <td>
                            <span :class="{ red: g.clsm_is_progress }">{{ convertProgress(g.clsm_is_progress) }}</span>
                        </td>
                        <td>{{ g.cs_center_staff_nm }}</td>
                        <td>
                            {{ g.clsm_less_start_dt | timestampFilter }} ~ {{ g.clsm_less_end_dt | timestampFilter }}
                        </td>
                        <td>{{ convertWeek(g.clsm_schd_rep_week) }}</td>
                        <td>{{ g.clsm_less_start_tm | timeCutter }}</td>
                        <td>{{ convertMinutes(g.clsm_less_total_tm) }}</td>
                        <td>{{ g.clsm_less_nm }}</td>
                        <td>{{ g.clsm_less_mem_max_cnt }}</td>
                        <td>{{ g.clsm_less_mem_wait_enable_cnt }}</td>
                        <td>{{ g.clsm_cre_dt | timestampFilter }}</td>
                        <td>{{ g.clsm_center_nm }}</td>
                        <td>
                            <button class="com-btn" @click="editPopup(g.clsm_center_less_schd_master_id)">수정</button>
                            <router-link
                                :to="{
                                    name: 'CourseHistory',
                                    params: {
                                        name: g.clsm_less_nm,
                                        time: g.clsm_less_start_tm,
                                        week: g.clsm_schd_rep_week,
                                        id: g.clsm_center_less_schd_master_id,
                                        total: g.clsm_less_total_tm,
                                    },
                                }"
                                class="com-btn deep-blue"
                            >
                                히스토리 내역
                            </router-link>
                            <!-- <button class="com-btn deep-blue">히스토리 내역</button> -->
                        </td>
                    </tr>
                    <tr v-if="groupLessonList == 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
        </div>

        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        />

        <!-- 그룹레슨 등록 팝업 -->
        <div v-show="lessonPop" class="layer-pop square-type">
            <div class="view-content w880">
                <button class="close" @click="closeLessonPopup"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">
                        그룹레슨 등록
                        <!--<button class="com-btn red float-right">삭제</button>-->
                    </span>
                    <table class="com-table left">
                        <colgroup>
                            <col style="width: 140px" />
                            <col style="width: 570px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    강사명
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <select-form
                                        :select-data="['선택', ...teacherList]"
                                        :select-value="['', ...teacherValueList]"
                                        :selected-value="teacherStaff"
                                        class="w200"
                                        @update:set="(val) => (teacherStaff = val)"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    수업기간
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div class="com-calendar-wrap">
                                        <single-calendar
                                            :start-date="startDate"
                                            @update="startDateUpdate"
                                        ></single-calendar>
                                        <div class="com-dash"><span class="dash">~</span></div>
                                        <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                                    </div>
                                    <p class="notice-txt">종료일자는 시작일자로부터 1년 이내로 설정해주세요.</p>
                                </td>
                            </tr>

                            <template v-for="(schedule, sindex) in schedules">
                                <tr :key="`schedule-${sindex}-week`">
                                    <th>
                                        수업 일정
                                        <span class="imp">*</span>
                                    </th>
                                    <td>
                                        <div
                                            class="com-check"
                                            v-for="(week, windex) in weekdayIndex"
                                            :key="`schedule-${sindex}-week-${windex}`"
                                        >
                                            <input
                                                :id="`check-r${sindex}-${windex}`"
                                                v-model="schedule.repeatWeek[windex]"
                                                false-value="X"
                                                :name="`check-r${sindex}`"
                                                true-value="O"
                                                type="checkbox"
                                            />
                                            <label :for="`check-r${sindex}-${windex}`">{{ week }}</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr :key="`schedule-${sindex}-time`">
                                    <th></th>
                                    <td>
                                        <div class="flex">
                                            <select-form
                                                :select-data="selectFormStartHour.data"
                                                :select-value="selectFormStartHour.value"
                                                :selected-value="schedule.startHour"
                                                class="w100"
                                                @update:set="(value) => (schedule.startHour = value)"
                                            />
                                            <span class="dot">:</span>
                                            <select-form
                                                :select-data="selectFormStartMin.data"
                                                :select-value="selectFormStartMin.value"
                                                :selected-value="schedule.startMin"
                                                class="w100"
                                                @update:set="(value) => (schedule.startMin = value)"
                                            />
                                            <select-form
                                                :select-data="selectFormLessonTime.data"
                                                :select-value="selectFormLessonTime.value"
                                                :selected-value="schedule.lessonTime"
                                                class="w120"
                                                @update:set="(value) => (schedule.lessonTime = value)"
                                            />
                                            <button
                                                v-if="sindex == schedules.length - 1"
                                                class="com-btn blue"
                                                @click="onNewSchedule"
                                            >
                                                일정 추가
                                            </button>
                                            <button v-else class="com-btn" @click="onRemvoeSchedule(sindex)">
                                                일정 삭제
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </template>

                            <tr>
                                <th>룸 선택</th>
                                <td>
                                    <select-form
                                        class="w120"
                                        :select-data="['선택안함', ...rooms.data]"
                                        :select-value="[null, ...rooms.value]"
                                        :selected-value="rooms.selectedValue"
                                        @update:set="selectRoom"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    프로그램명
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <input v-model="lessonName" class="w100p" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    최대예약 인원
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div class="flex">
                                        <input v-model="lessonMemberMaxCount" class="w60 center" type="text" />
                                        <span class="txt">명 까지만 예약이 가능합니다.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>대기가능 인원</th>
                                <td>
                                    <div class="flex">
                                        <input v-model="lessonMemberWaitEnableCount" class="w60 center" type="text" />
                                        <span class="txt">명 까지만 대기가 가능합니다.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>강제휴강 인원</th>
                                <td>
                                    <div class="line">
                                        <div class="com-radio">
                                            <input
                                                id="radio-r1-1"
                                                v-model="lessonForceOffYn"
                                                name="radio-r1"
                                                type="radio"
                                                :value="false"
                                            />
                                            <label for="radio-r1-1">휴강안함</label>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <div class="flex">
                                            <div class="com-radio">
                                                <input
                                                    id="radio-r1-2"
                                                    v-model="lessonForceOffYn"
                                                    name="radio-r1"
                                                    type="radio"
                                                    :value="true"
                                                />
                                                <label for="radio-r1-2">시작시간</label>
                                            </div>
                                            <input v-model="lessonForceOffCondTime" class="w60 center" type="text" />
                                            <span class="txt">분 전까지</span>
                                            <input v-model="lessonForceOffMenberCount" class="w60 center" type="text" />
                                            <span class="txt">명 미만으로 예약 시, 휴강합니다.</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>대기시 자동예약</th>
                                <td>
                                    <div class="line">
                                        <div class="com-radio">
                                            <input
                                                id="radio-2-1"
                                                v-model="autoResvYn"
                                                name="radio-2"
                                                type="radio"
                                                value="N"
                                            />
                                            <label for="radio-2-1">사용안함</label>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <div class="flex">
                                            <div class="com-radio">
                                                <input
                                                    id="radio-2-2"
                                                    v-model="autoResvYn"
                                                    name="radio-2"
                                                    type="radio"
                                                    value="Y"
                                                />
                                                <label for="radio-2-2">수업시작</label>
                                            </div>
                                            <select-form
                                            :disabled="this.autoResvYn !== 'Y'"
                                            :select-data="optionsHours"
                                            :select-value="valuesHours"
                                            :selected-value.sync="autoResvLimitHour"
                                            class="w80 ml-2"
                                            @update:set="(v) => $forceUpdate()"
                                              ></select-form>
                                            <span class="txt center ml-2">시간</span>
                                            <select-form
                                            :disabled="this.autoResvYn !== 'Y'"
                                            :select-data="optionsMinutes"
                                            :select-value="valuesMinutes"
                                            :selected-value.sync="autoResvLimitMin"
                                            class="w80 ml-2"
                                            @update:set="(v) => $forceUpdate()"
                                             ></select-form>
                                            <span class="txt center">분 전 수업 취소 시 자동 예약 됩니다.</span>
                                    </div>
                                </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    예약 가능한
                                    <br />
                                    이용권 카테고리
                                </th>
                                <td>
                                    <select-check-form
                                        :callback-change-check="(v) => (selectedCategories = v)"
                                        :select-data="[...categoryList]"
                                        :select-value="[...categoryValList]"
                                        :selected-value="selectedCategories"
                                        class="w100p"
                                        title="전체"
                                    ></select-check-form>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- <div class="com-btn-area">
              <div class="left-box">
                  <button class="com-btn" @click="teacherPop = true">강사변경</button>
              </div>
          </div> -->
                    <div class="bottom-btn">
                        <button class="com-btn" @click="closeLessonPopup">취소</button>
                        <button class="com-btn blue" @click="onPostItem">등록</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 그룹레슨 수정 팝업 -->
        <div v-show="lessonModifyPop" class="layer-pop square-type">
            <div class="view-content w880">
                <button class="close" @click="onClickBtnCloseModify"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span v-if="isModeChangeTeacher" class="sub-title">강사변경</span>
                    <span v-else class="sub-title">
                        그룹레슨 수정
                        <button class="com-btn red float-right" @click="onClickBtnDeleteGroupLesson()">삭제</button>
                    </span>
                    <table class="com-table left">
                        <colgroup>
                            <col style="width: 140px" />
                            <col style="width: 570px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    강사명
                                    <span class="imp">*</span>
                                </th>
                                <td v-if="isModeChangeTeacher">
                                    <select-form
                                        class='w200'
                                        :select-data="['강사명', ...teacherList]"
                                        :select-value="['', ...teacherValueList]"
                                        :selected-value="editField.lessonStaffId"
                                        disabled
                                    />
                                    <span class="dash">&gt;</span>
                                    <select-form
                                        class='w200'
                                        :select-data="['선택', ...teacherList]"
                                        :select-value="['', ...teacherValueList]"
                                        :selected-value="editStaff.lessonId"
                                        @update:set="updateNextTeacher"
                                    />
                                </td>
                                <td v-else>
                                    <select-form
                                        class='w200'
                                        :select-data="['강사명', ...teacherList]"
                                        :select-value="['', ...teacherValueList]"
                                        :selected-value="editField.lessonStaffId"
                                        disabled
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    수업기간
                                    <span class="imp">*</span>
                                </th>
                                <td v-if="isModeChangeTeacher">
                                    <div class="com-calendar-wrap flex-col">
                                        변경전
                                        <div class="flex mt-4">
                                            <single-calendar
                                                :start-date="editField.changeTeacher.prevStartDate"
                                                disabled
                                            />
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <single-calendar
                                                :disabled-before-today="true"
                                                :min-date='editField.changeTeacher.prevStartDate'
                                                :end-date="editField.changeTeacher.prevEndDate"
                                                @update="updatePrevEndDate"
                                            />
                                        </div>

                                        <br />
                                        변경후
                                        <div class="flex mt-4">
                                            <single-calendar
                                                :start-date="editField.changeTeacher.nextStartDate"
                                                disabled
                                            />
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <single-calendar
                                                :min-date='editField.changeTeacher.nextStartDate'
                                                :end-date="editField.changeTeacher.nextEndDate"
                                                @update="updateNextEndDate"
                                            />
                                        </div>
                                    </div>
                                    <p class="notice-txt">종료일자는 시작일자로부터 1년 이내로 설정해주세요.</p>
                                </td>
                                <td v-else>
                                    <div class="com-calendar-wrap">
                                        <single-calendar
                                            :start-date="editField.lessonStartDate"
                                            disabled
                                            @update="editStartDateUpdate"
                                        />
                                        <div class="com-dash"><span class="dash">~</span></div>
                                        <single-calendar
                                            :end-date="editField.lessonEndDate"
                                            :min-date='editField.lessonStartDate'
                                            @update="editEndDateUpdate"
                                        />
                                    </div>
                                    <p class="notice-txt">종료일자는 시작일자로부터 1년 이내로 설정해주세요.</p>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    수업요일
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div v-for="(wd, index) in weekdayIndex" :key="index" class="com-check">
                                        <input
                                            :id="`check-r1-${index}`"
                                            :checked="editField.scheduleRepeatWeek[index] == 'O'"
                                            :name="`check-r1-${index}`"
                                            type="checkbox"
                                        />
                                        <label
                                            @click="
                                                editField.scheduleRepeatWeek[index] =
                                                    editField.scheduleRepeatWeek[index] === 'O' ? 'X' : 'O'
                                            "
                                            :for="`check-r1-${index}`"
                                        >
                                            {{ wd }}
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    수업시작시간
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <select-form
                                        :select-data="selectFormStartHour.data"
                                        :select-value="selectFormStartHour.value"
                                        :selected-value="splitStartTime[0]"
                                        class="w100"
                                        @update:set="updateReserveHour"
                                    ></select-form>
                                    <span class="dot">:</span>
                                    <select-form
                                        :select-data="selectFormStartMin.data"
                                        :select-value="selectFormStartMin.value"
                                        :selected-value="splitStartTime[1]"
                                        class="w100"
                                        @update:set="updateReserveMin"
                                    ></select-form>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    수업진행시간
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <select-form
                                        :select-data="selectFormLessonTime.data"
                                        :select-value="selectFormLessonTime.value"
                                        :selected-value="editField.lessonTotalTime"
                                        class="w120"
                                        @update:set="updateLessonTime"
                                    ></select-form>
                                </td>
                            </tr>
                            <tr>
                                <th>룸 선택</th>
                                <td>
                                    <select-form
                                        class="w120"
                                        :select-data="['선택안함', ...rooms.data]"
                                        :select-value="[null, ...rooms.value]"
                                        :selected-value="rooms.selectedValue"
                                        @update:set="selectRoom"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    프로그램명
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <input v-model="editField.lessonName" class="w100p" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    최대예약 인원
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div class="flex">
                                        <input
                                            v-model="editField.lessonMemberMaxCount"
                                            class="w60 center"
                                            type="text"
                                            value="0"
                                        />
                                        <span class="txt">명 까지만 예약이 가능합니다.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>대기가능 인원</th>
                                <td>
                                    <div class="flex">
                                        <input
                                            v-model="editField.lessonMemberWaitEnableCount"
                                            class="w60 center"
                                            type="text"
                                            value="0"
                                        />
                                        <span class="txt">명 까지만 대기가 가능합니다.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>강제휴강 인원</th>
                                <td>
                                    <div class="line">
                                        <div class="com-radio">
                                            <input
                                                id="edit-radio-r1-1"
                                                v-model="editField.lessonForceOffYn"
                                                name="edit-radio-r1"
                                                type="radio"
                                                :value="false"
                                            />
                                            <label for="edit-radio-r1-1">휴강안함</label>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <div class="flex">
                                            <div class="com-radio">
                                                <input
                                                    id="edit-radio-r1-2"
                                                    v-model="editField.lessonForceOffYn"
                                                    name="edit-radio-r1"
                                                    type="radio"
                                                    :value="true"
                                                />
                                                <label for="edit-radio-r1-2">시작시간</label>
                                            </div>
                                            <input
                                                v-model="editField.lessonForceOffCondTime"
                                                class="w60 center"
                                                type="text"
                                            />
                                            <span class="txt">분 전까지</span>
                                            <input
                                                v-model="editField.lessonForceOffMenberCount"
                                                class="w60 center"
                                                type="text"
                                            />
                                            <span class="txt">명 미만으로 예약 시, 휴강합니다.</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>대기시 자동예약</th>
                                <td>
                                    <div class="line">
                                        <div class="com-radio">
                                            <input
                                                id="radio-3-1"
                                                v-model="editField.autoResvYn"
                                                name="radio-3"
                                                type="radio"
                                                value="N"
                                            />
                                            <label for="radio-3-1">사용안함</label>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <div class="flex">
                                            <div class="com-radio">
                                                <input
                                                    id="radio-3-2"
                                                    v-model="editField.autoResvYn"
                                                    name="radio-3"
                                                    type="radio"
                                                    value="Y"
                                                />
                                                <label for="radio-3-2">수업시작</label>
                                            </div>
                                            <select-form
                                                :disabled="editField.autoResvYn !== 'Y'"
                                                :select-data='optionsHours'
                                                :select-value='valuesHours'
                                                :selected-value.sync='editField.autoResvLimitHour'
                                                class='w80 ml-2'
                                                @update:set='(v) => $forceUpdate()'
                                            />
                                            <span class='txt center ml-2'>시간</span>
                                            <select-form
                                                :disabled="editField.autoResvYn !== 'Y'"
                                                :select-data='optionsMinutes'
                                                :select-value='valuesMinutes'
                                                :selected-value.sync='editField.autoResvLimitMin'
                                                class='w80 ml-2'
                                                @update:set='(v) => $forceUpdate()'
                                            />
                                            <span class="txt center">분 전 수업 취소 시 자동 예약 됩니다.</span>
                                    </div>
                                </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    예약 가능한
                                    <br />
                                    이용권 카테고리
                                </th>
                                <td>
                                    <select-check-form
                                        :callback-change-check="(v) => (editField.selectedCategories = v)"
                                        :select-data="[...categoryList]"
                                        :select-value="[...categoryValList]"
                                        :selected-value="editField.selectedCategories"
                                        class="w100p"
                                        title="전체"
                                    ></select-check-form>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="com-btn-area">
                        <div v-if="!isModeChangeTeacher" class="left-box">
                            <button
                                :disabled="!isAbleToChangeTeacher"
                                class="com-btn"
                                @click="onClickBtnShowChangeTeacher"
                            >
                                강사변경
                            </button>
                        </div>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickBtnCancelModify">취소</button>
                        <button class="com-btn blue" @click="onClickBtnModify">수정</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 강사변경 팝업 -->
        <div v-show="teacherPop" class="layer-pop square-type">
            <div class="view-content w880">
                <button class="close" @click="teacherPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">강사변경</span>
                    <table class="com-table left">
                        <colgroup>
                            <col style="width: 140px" />
                            <col style="width: 570px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    강사명
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <select-form
                                        :select-data="['강사명', ...teacherList]"
                                        :select-value="['', ...teacherValueList]"
                                        :selected-value="editField.lessonStaffId"
                                        disabled
                                    ></select-form>
                                    <span class="dash">&gt;</span>
                                    <select-form
                                        :select-data="['선택', ...teacherList]"
                                        :select-value="['', ...teacherValueList]"
                                        :selected-value="editField.changeTeacher.lessonStaffId"
                                        @update:set="(val) => (editField.changeTeacher.lessonStaffId = val)"
                                    ></select-form>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    수업기간
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div class="com-calendar-wrap">
                                        변경전
                                        <br />
                                        <single-calendar
                                            :start-date="editField.changeTeacher.prevStartDate"
                                            disabled
                                        />
                                        <div class="com-dash"><span class="dash">~</span></div>
                                        <single-calendar
                                            :disabled-before-today="true"
                                            :min-date='editField.changeTeacher.prevStartDate'
                                            :end-date="editField.changeTeacher.prevEndDate"
                                            @update="updatePrevEndDate"
                                        />
                                        <br />
                                        변경후
                                        <br />
                                        <single-calendar
                                            :start-date="editField.changeTeacher.nextStartDate"
                                            disabled
                                        />
                                        <div class="com-dash"><span class="dash">~</span></div>
                                        <single-calendar
                                            :min-date='editField.changeTeacher.nextStartDate'
                                            :end-date="editField.changeTeacher.nextEndDate"
                                            @update="updateNextEndDate"
                                        />
                                    </div>
                                    <p class="notice-txt">종료일자는 시작일자로부터 1년 이내로 설정해주세요.</p>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    수업요일
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div v-for="(wd, index) in weekdayIndex" :key="index" class="com-check">
                                        <input
                                            :id="`check-r1-${index}`"
                                            :checked="editField.scheduleRepeatWeek[index] == 'O'"
                                            name="check-r1"
                                            type="checkbox"
                                        />
                                        <label :for="`check-r1-${index}`">{{ wd }}</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    수업시작시간
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <select-form
                                        :select-data="selectFormStartHour.data"
                                        :select-value="selectFormStartHour.value"
                                        :selected-value="splitStartTime[0]"
                                        class="w100"
                                        @update:set="updateReserveHour"
                                    ></select-form>
                                    <span class="dot">:</span>
                                    <select-form
                                        :select-data="selectFormStartMin.data"
                                        :select-value="selectFormStartMin.value"
                                        :selected-value="splitStartTime[1]"
                                        class="w100"
                                        @update:set="updateReserveMin"
                                    ></select-form>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    수업진행시간
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <select-form
                                        :select-data="selectFormLessonTime.data"
                                        :select-value="selectFormLessonTime.value"
                                        :selected-value="editField.lessonTotalTime"
                                        class="w120"
                                        disabled
                                        @update:set="updateLessonTime"
                                    ></select-form>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    프로그램명
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <input v-model="editField.lessonName" class="w100p" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    최대예약 인원
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div class="flex">
                                        <input
                                            v-model="editField.lessonMemberMaxCount"
                                            class="w60 center"
                                            type="text"
                                            value="0"
                                        />
                                        <span class="txt">명 까지만 예약이 가능합니다.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>대기가능 인원</th>
                                <td>
                                    <div class="flex">
                                        <input
                                            v-model="editField.lessonMemberWaitEnableCount"
                                            class="w60 center"
                                            type="text"
                                            value="0"
                                        />
                                        <span class="txt">명 까지만 대기가 가능합니다.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>강제휴강 인원</th>
                                <td>
                                    <div class="line">
                                        <div class="com-radio">
                                            <input
                                                id="stf-radio-r1-1"
                                                v-model="editField.lessonForceOffYn"
                                                name="stf-radio-r1"
                                                type="radio"
                                                value="false"
                                            />
                                            <label for="stf-radio-r1-1">휴강안함</label>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <div class="flex">
                                            <div class="com-radio">
                                                <input
                                                    id="stf-radio-r1-2"
                                                    v-model="editField.lessonForceOffYn"
                                                    name="stf-radio-r1"
                                                    type="radio"
                                                    value="true"
                                                />
                                                <label for="stf-radio-r1-2">시작시간</label>
                                            </div>
                                            <input
                                                v-model="editField.lessonForceOffCondTime"
                                                class="w60 center"
                                                type="text"
                                            />
                                            <span class="txt">분 전까지</span>
                                            <input
                                                v-model="editField.lessonForceOffMenberCount"
                                                class="w60 center"
                                                type="text"
                                            />
                                            <span class="txt">명 미만으로 예약 시, 휴강합니다.</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <th>
                                    예약 가능한
                                    <br />
                                    이용권 카테고리
                                </th>
                                <td>
                                    <select-check-form
                                        :select-data="[...categoryList]"
                                        :select-value="[...categoryValList]"
                                        class="w100p"
                                        title="전체"
                                    ></select-check-form>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="bottom-btn">
                        <!--                        <button class="com-btn" @click="teacherPop = false">취소</button>-->
                        <!--                        <button class="com-btn blue" @click="staffChange">변경</button>-->
                    </div>
                </div>
            </div>
        </div>

        <!-- 그룹레슨 일괄수정 팝업 -->
        <div v-show="lessonModifyBatchPop" class="layer-pop square-type">
            <div class="view-content w880">
                <button class="close" @click="closeBatchModifyPopup"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">그룹레슨 일괄수정</span>

                    <table class="com-table left">
                        <colgroup>
                            <col style="width: 140px" />
                            <col style="width: 570px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    강사명
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <select-form
                                        class='w200'
                                        :select-data="['선택', ...teacherList]"
                                        :select-value="['', ...teacherValueList]"
                                        :selected-value="editField.changeTeacher.lessonStaffId"
                                        @update:set="(val) => (editField.changeTeacher.lessonStaffId = val)"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    프로그램명
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <input v-model="editField.lessonName" class="w100p" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    최대예약 인원
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div class="flex">
                                        <input
                                            v-model.number="editField.lessonMemberMaxCount"
                                            class="w60 center"
                                            type="number"
                                            value="0"
                                        />
                                        <span class="txt">명 까지만 예약이 가능합니다.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>대기가능 인원</th>
                                <td>
                                    <div class="flex">
                                        <input
                                            v-model.number="editField.lessonMemberWaitEnableCount"
                                            class="w60 center"
                                            type="number"
                                            value="0"
                                        />
                                        <span class="txt">명 까지만 대기가 가능합니다.</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>강제휴강 인원</th>
                                <td>
                                    <div class="line">
                                        <div class="com-radio">
                                            <input
                                                id="edit-radio-r2-1"
                                                v-model="editField.lessonForceOffYn"
                                                name="edit-radio-r2"
                                                type="radio"
                                                :value="false"
                                            />
                                            <label for="edit-radio-r2-1">휴강안함</label>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <div class="flex">
                                            <div class="com-radio">
                                                <input
                                                    id="edit-radio-r2-2"
                                                    v-model="editField.lessonForceOffYn"
                                                    name="edit-radio-r2"
                                                    type="radio"
                                                    :value="true"
                                                />
                                                <label for="edit-radio-r2-2">시작시간</label>
                                            </div>
                                            <input
                                                v-model.number="editField.lessonForceOffCondTime"
                                                class="w60 center"
                                                type="number"
                                            />
                                            <span class="txt">분 전까지</span>
                                            <input
                                                v-model.number="editField.lessonForceOffMenberCount"
                                                class="w60 center"
                                                type="number"
                                            />
                                            <span class="txt">명 미만으로 예약 시, 휴강합니다.</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    예약 가능한
                                    <br />
                                    이용권 카테고리
                                </th>
                                <td>
                                    <select-check-form
                                        :callback-change-check="(v) => (editField.selectedCategories = v)"
                                        :select-data="[...categoryList]"
                                        :select-value="[...categoryValList]"
                                        :selected-value="editField.selectedCategories"
                                        class="w100p"
                                        title="전체"
                                    ></select-check-form>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="closeBatchModifyPopup">취소</button>
                        <button class="com-btn blue" @click="handleBatchUpdate">수정</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import { Utils } from '@/assets/js/utils';
import { pagingInfo } from '@/assets/js/common';
import {mapGetters} from 'vuex';

let modifyGroupLesson_flag = false;
export default {
    name: 'CourseLesson',
    props: {},
    computed: {
        ...mapGetters({
            centerId: 'auth/cId',
        }),
        isAbleToChangeTeacher() {
            const { editField } = this;
            const today = moment().format('YYYY-MM-DD');
            return moment(editField.data.lessonEndDate).isAfter(today);
        },
        isModeChangeTeacher: {
            get() {
                return this.editField.mode === 'change';
            },
            set(bVal) {
                this.editField.mode = bVal ? 'change' : 'modify';
            },
        },
    },
    watch: {
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;
        },
        progress(newValue) {
            this.progress = newValue;
            this.onSearchList();
        },
        teacherStaff(newValue) {
            // 강사명
            this.teacherStaff = newValue;
            this.onSearchList();
        },
        changeStaffId(newValue) {
            console.log(newValue);
            this.editStaff.lessonStaffId = newValue;
        },
        searchTeacherStaff(newValue) {
            this.searchTeacherStaff = newValue;
            this.onSearchList();
        },
    },
    data() {
        return {
            isLoading: false,

            rooms: { data: [], value: [], selectedValue: null },
            initCategory: [],
            centerStaffId: this.$store.state.auth.user.uid,
            pagingInfo: { ...pagingInfo },
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            lessonPop: false, // 그룹레슨 등록 팝업
            lessonModifyPop: false, // 그룹레슨 수정 팝업
            lessonModifyBatchPop: false, // 그룹레슨 일괄수정 팝업
            teacherPop: false, // 강사변경 팝업
            weekdayIndex: ['월', '화', '수', '목', '금', '토', '일'],
            groupLessonList: [],
            totalItems: '',
            progress: 'true',

            lessonName: '',
            lessonMemberMaxCount: 0,
            lessonMemberWaitEnableCount: 0,
            lessonForceOffCondTime: 0,
            lessonForceOffMenberCount: 0,

            startDate: '',
            endDate: '',
            lessonStartTime: '',
            lessonEndTime: '',
            centerLessonScheduleMasterId: '',

            scheduleRepeatWeek: ['X', 'X', 'X', 'X', 'X', 'X', 'X'],

            schedules: [],

            staffNumber: parseInt(this.$store.state.auth.user.uid),
            lessonForceOffYn: '', // 기본값 false
            teacherList: [], // 강사리스트
            teacherValueList: [], // 강사아이디 리스트
            searchStr: '',

            staffSearchList: [],
            staffSearchValueList: [],
            staffValList: '',

            categoryList: ['전체'],
            categoryValList: ['all'],

            // 시간관련 데이터
            selectFormStartHour: {
                data: [],
                value: [],
                selectedValue: '00',
            },
            selectFormStartMin: {
                data: [],
                value: [],
                selectedValue: '00',
            },
            selectFormLessonTime: {
                data: ['30분', '1시간', '1시간 30분', '2시간', '2시간 30분', '3시간'],
                value: [30, 60, 90, 120, 150, 180],
                selectedValue: 60,
            },
            lessonDate: moment().format('YYYY-MM-DD'), // 임시값.

            selectedCategories: [],
            productCategorys: [],

            autoResvYn : 'N',
            autoResvLimitHour : "0",
            autoResvLimitMin : "0",

            // 수정을 위한 데이터값
            editField: {
                data: {},
                mode: 'modify',
                lessonStaffId: '',
                lessonStartDate: '',
                lessonEndDate: '',
                scheduleRepeatWeek: ['X', 'X', 'X', 'X', 'X', 'X', 'X'],
                lessonStartTime: '',
                lessonEndTime: '',
                lessonTotalTime: '',
                lessonName: '',
                lessonMemberMaxCount: '',
                lessonMemberWaitEnableCount: '',
                lessonForceOffYn: '',
                lessonForceOffCondTime: '',
                lessonForceOffMenberCount: '',
                productCategorys: [],
                selectedCategories: [],
                changeTeacher: {
                    lessonStaffId: '',
                    prevStartDate: '',
                    prevEndDate: '',
                    nextStartDate: '',
                    nextEndDate: '',
                },
                autoResvYn : 'N',
                autoResvLimitHour : '0',
                autoResvLimitMin : '0',
            },
            splitStartTime: [], // 수업시작시간 배열
            teacherStaff: '', // 강사명
            // 스태프 강사변경시 필요한 값들
            editStaff: {
                lessonStaffId: '', // 변경된 강사 아이디
                lessonStartDate: '', // 변경날짜
                lessonEndDate: '', // 변경날짜
            },
            editStartDate: '',
            finalEndDate: '',
            searchTeacherStaff: '',

            flag: true,
            changeDate: '', // 변경되는 날짜
            orgEndDate: '', // 변경되기전 날짜.

            selectAll: false, // 전체 선택 해제
            checkLessonList: [], // 체크박스 선택한 회원 목록

            optionsHours: _.range(0, 24).map((v) => String(v)),
            valuesHours: _.range(0, 24).map((v) => String(v)),
            optionsMinutes: _.range(0, 60).map((v) => String(v)),
            valuesMinutes: _.range(0, 60).map((v) => String(v)),

        };
    },
    mounted() {
        this.init();
    },
    methods: {
        getCenterRoomReservation(centerRoomId) {
            const lessonStartDate = moment(this.startDate || this.editField.lessonStartDate).format('YYYYMMDD');
            const lessonEndDate = moment(this.endDate || this.editField.lessonEndDate).format('YYYYMMDD');

            const {
                centerId,
                lessonDate,
                selectFormStartHour,
                selectFormStartMin,
                selectFormLessonTime,
                scheduleRepeatWeek,
                editField,
            } = this;
            console.log('editField =>', editField);
            const tmFormat = 'HH:mm:ss';
            const dtFormat = 'YYYY-MM-DD HH:mm:ss';
            const startTime = `${selectFormStartHour.selectedValue}:${selectFormStartMin.selectedValue}:00`;

            const lessonStartDatetime = `${lessonDate} ${startTime}`;

            const endTime = moment(lessonStartDatetime, dtFormat)
                .add(selectFormLessonTime.selectedValue, 'minutes')
                .format(tmFormat);

            // 스웨거 검색: 룸 예약 현황 조회
            return api.get(`/admin/api/centerRoom/reservation/status/group`, {
                params: {
                    centerId,
                    lessonStartTime: startTime,
                    lessonEndTime: endTime,
                    centerRoomId,
                    lessonStartDate,
                    lessonEndDate,
                    scheduleRepeatWeek:
                        editField.mode === 'modify'
                            ? editField.scheduleRepeatWeek.join(':')
                            : scheduleRepeatWeek.join(':'),
                },
            });
        },
        async selectRoom(centerRoomId, num) {
            try {
                const { data } = await this.getCenterRoomReservation(centerRoomId);
                if (data === 1) {
                    this.rooms.selectedValue = centerRoomId;
                } else if (data) {
                    alert(data);
                } else {
                    this.rooms.selectedValue = centerRoomId;
                }
            } catch (e) {
                console.log(e);
            }
        },
        getCenterRooms() {
            return api.get(`/admin/api/centerRoom/${this.centerId}`);
        },
        async fetchCenterRooms() {
            try {
                const { data } = await this.getCenterRooms();
                this.rooms.data = data.map((element) => {
                    if (element.useYn) {
                        return element.name;
                    }
                });
                // this.rooms.data.unshift("선택안함")
                this.rooms.value = data.map((element) => {
                    if (element.useYn) {
                        return element.centerRoomId;
                    }
                });
                // this.rooms.value.unshift("")
                this.rooms.selectedValue = null;
            } catch (e) {
                console.log(e);
            }
        },
        // 초기화
        async init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            await this.fetchSearchList(); // 스태프 컬럼
            await this.fetchStaffList();
            await this.onSearchList();
            await this.fetchReservationSetting(); // 강사별 세팅 시간 가져오기
            await this.fetchCategory();
            await this.fetchCenterRooms();

            const { selectFormStartHour, selectFormStartMin } = this;

            // 수업시작 시간 : 시
            for (let h = 0; h < 24; h++) {
                const hour = h.toString().padStart(2, '0');
                selectFormStartHour.data.push(hour);
                selectFormStartHour.value.push(hour);
            }
            // 수업시작 시간 : 분
            const timeUnitValue = this.reservationSetting.timeUnitValue;
            if (timeUnitValue < 60) {
                for (let m = 0; m < 60; m += timeUnitValue) {
                    const min = m.toString().padStart(2, '0');
                    selectFormStartMin.data.push(min);
                    selectFormStartMin.value.push(min);
                }
            } else {
                selectFormStartMin.data.push('00');
                selectFormStartMin.value.push('00');
            }
        },
        async fetchCategory() {
            try {
                const { data } = await this.getSearchCategory();
                data.forEach((g) => {
                    this.categoryList.push(g.name);
                    this.categoryValList.push(g.centerProductCategoryTemplateId);
                });
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        // 그룹레슨 목록 조회
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getSearchList();
                this.setPageParams(data);
                this.groupLessonList = data.items;
                this.totalItems = data.meta.totalItems;
            } catch (error) {
                console.log(error);
            }

            this.isLoading = false;
        },
        // 그룹레슨 목록 조회 API
        getSearchList() {
            // 스웨거 검색: 그룹레슨 페이징 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/lesson/groupLesson/paging`, {
                params: {
                    searchStr: this.searchStr,
                    isProgress: this.progress,
                    lessonStaffId: this.searchTeacherStaff,
                    ...this.pagingInfo,
                },
            });
        },
        // 진행여부
        convertProgress(type) {
            if (type == true) {
                return '진행중';
            } else if (type == false) {
                return '종료됨';
            }
        },
        // 수업요일 변환
        convertWeek(weeks) {
            const week1 = weeks.split(':');
            const week = ['월', '화', '수', '목', '금', '토', '일'];
            let str = '';
            for (let i = 0; i < week1.length; i++) {
                if (week1[i] == 'O') str += `${week[i]},`;
            }
            return str.slice(0, -1);
        },

        // 전체선택 체크박스 선택시
        allCheckBox() {
            const checkBoxArray = document.getElementsByName('check-1');
            const allCheckBox = document.getElementsByName('check-1')[0];
            const checkBoxLength = checkBoxArray.length;
            if (this.isLast) {
                this.isLast = false;
                return;
            }

            for (let i = 1; i < checkBoxLength; i += 1) {
                if (allCheckBox.checked === true && checkBoxArray[i].checked === false) {
                    checkBoxArray[i].click();
                } else if (allCheckBox.checked === false && checkBoxArray[i].checked === true) {
                    checkBoxArray[i].click();
                }
            }
        },

        // 일정 추가
        onNewSchedule() {
            this.schedules.push({
                repeatWeek: ['X', 'X', 'X', 'X', 'X', 'X', 'X'],
                startHour: '00',
                startMin: '00',
                lessonTime: 60,
            });
        },

        // 일정 삭제
        onRemvoeSchedule(index) {
            this.schedules.splice(index, 1);
        },

        closeLessonPopup() {
            this.lessonPop = false;
        },

        // 등록버튼
        async onPostItem() {
            try {
                // 필수값 체크
                const validate = this.validateReturnValues();
                if (!validate.result) {
                    alert(validate.msg);
                    return false;
                }

                for (let i = 0; i < this.schedules.length; i += 1) {
                    await this.postItem(this.schedules[i]);
                }

                // 그룹레슨 닫기
                this.closeLessonPopup();

                // 등록값들 초기화해주기.
                await this.onSearchList(); // 조회
            } catch (error) {
                Utils.alertResponseErrorMessge(error);
                console.log(error);
                console.log('에러 입니다.');
            }
        },
        // 파라미터 validate
        validateReturnValues() {
            // 필수값 체크
            let result = false;
            // 강사명, 수업기간,수업요일,수업시작시간,진행시간,프로그램명,최대예약인원
            const { teacherStaff, scheduleRepeatWeek, lessonName, lessonMemberMaxCount, schedules } = this;
            let msg = '';

            // 회원명
            if (teacherStaff === '' || teacherStaff === undefined) {
                msg = '강사를 선택하세요.';
                return {
                    result,
                    msg,
                };
            }

            // 수업요일
            if (schedules.filter((s) => !s.repeatWeek.includes('O')).length) {
                msg = '수업요일을 선택하세요.';
                return {
                    result,
                    msg,
                };
            }

            // 프로그램명
            if (lessonName === '' || lessonName === undefined) {
                msg = '프로그램명을 입력하세요.';
                return {
                    result,
                    msg,
                };
            }
            // 최대예약인원
            if (lessonMemberMaxCount === '' || lessonMemberMaxCount === undefined) {
                msg = '최대예약 인원을 선택하세요.';
                return {
                    result,
                    msg,
                };
            }

            if (msg !== '') {
                result = false;
            } else {
                result = true;
            }

            return {
                result,
                msg,
            };
        },

        // 등록 api 호출
        getPostItem() {
            const { lessonDate, selectFormLessonTime, selectFormStartHour, selectFormStartMin, selectedCustomer } =
                this;
            const tmFormat = 'HH:mm:ss';
            const dtFormat = 'YYYY-MM-DD HH:mm:ss';
            const startTime = `${selectFormStartHour.selectedValue}:${selectFormStartMin.selectedValue}:00`;

            const lessonStartDatetime = `${lessonDate} ${startTime}`;

            const endTime = moment(lessonStartDatetime, dtFormat)
                .add(selectFormLessonTime.selectedValue, 'minutes')
                .format(tmFormat);

            this.productCategorys = this.getProductCategoriesWithSelected(this.selectedCategories);

            // 스웨거 검색: 그룹레슨 등록
            return api.post(`/admin/api/center/${this.centerId}/lesson/group`, {
                lessonStaffId: this.teacherStaff,
                lessonStartDate: moment(this.startDate).format('YYYYMMDD'),
                lessonEndDate: moment(this.endDate).format('YYYYMMDD'),
                scheduleRepeatWeek: this.scheduleRepeatWeek.join(':'),
                lessonStartTime: startTime,
                lessonEndTime: endTime,
                lessonTotalTime: this.selectFormLessonTime.selectedValue,
                lessonName: this.lessonName,
                lessonMemberMaxCount: this.lessonMemberMaxCount,
                lessonMemberWaitEnableCount: this.lessonMemberWaitEnableCount ? this.lessonMemberWaitEnableCount : 0, // 대기인원
                lessonForceOffYn: this.lessonForceOffYn,
                lessonForceOffCondTime: this.lessonForceOffCondTime ? this.lessonForceOffCondTime : 0,
                lessonForceOffMenberCount: this.lessonForceOffMenberCount ? this.lessonForceOffMenberCount : 0,
                productCategorys: this.productCategorys,
                centerRoomId: this.rooms.selectedValue,
                roomPickYn: !!this.rooms.selectedValue,
            });
        },

        // 등록 api 호출
        postItem(schedule) {
            const { lessonDate, selectFormLessonTime, selectFormStartHour, selectFormStartMin, selectedCustomer } =
                this;
            const tmFormat = 'HH:mm:ss';
            const dtFormat = 'YYYY-MM-DD HH:mm:ss';
            const startTime = `${schedule.startHour}:${schedule.startMin}:00`;

            const lessonStartDatetime = `${this.lessonDate} ${startTime}`;

            const endTime = moment(lessonStartDatetime, dtFormat).add(schedule.lessonTime, 'minutes').format(tmFormat);

            this.productCategorys = this.getProductCategoriesWithSelected(this.selectedCategories);

            // 스웨거 검색: 그룹레슨 등록
            return api.post(`/admin/api/center/${this.centerId}/lesson/group`, {
                lessonStaffId: this.teacherStaff,
                lessonStartDate: moment(this.startDate).format('YYYYMMDD'),
                lessonEndDate: moment(this.endDate).format('YYYYMMDD'),
                scheduleRepeatWeek: schedule.repeatWeek.join(':'),
                lessonStartTime: startTime,
                lessonEndTime: endTime,
                lessonTotalTime: schedule.lessonTime,
                lessonName: this.lessonName,
                lessonMemberMaxCount: this.lessonMemberMaxCount,
                lessonMemberWaitEnableCount: this.lessonMemberWaitEnableCount ? this.lessonMemberWaitEnableCount : 0, // 대기인원
                lessonForceOffYn: this.lessonForceOffYn,
                lessonForceOffCondTime: this.lessonForceOffCondTime ? this.lessonForceOffCondTime : 0,
                lessonForceOffMenberCount: this.lessonForceOffMenberCount ? this.lessonForceOffMenberCount : 0,
                productCategorys: this.productCategorys,
                centerRoomId: this.rooms.selectedValue,
                roomPickYn: !!this.rooms.selectedValue,
                autoResvYn : this.autoResvYn || 'N',
                autoResvLimitHour : this.autoResvLimitHour || 0,
                autoResvLimitMin : this.autoResvLimitMin || 0,

            });
        },

        // 강사 리스트 조회 호출
        async fetchStaffList() {
            try {
                const { data } = await this.getStaffList();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                data.forEach((g) => {
                    this.teacherList.push(g.name);
                    this.teacherValueList.push(g.centerStaffId);
                });
            } catch (error) {
                console.log(error);
            }
        },
        // 강사 리스트 api
        getStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 회원 목록 키워드 검색 이벤트
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.onSearchList();
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            // this.onSearchList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            // this.onSearchList();
        },
        // 수정 검색 시작일 변경 event
        editStartDateUpdate(val) {
            this.editField.lessonStartDate = val;
            // this.onSearchList();
        },
        // 수정 검색 종료일 변경 event
        async editEndDateUpdate(val) {
            console.log('editEndDateUpdate', val);
            try {
                this.changeDate = val;
                const checkAfterStartDt = moment(val).isSameOrAfter(this.editField.lessonEndDate, 'day'); // 선택된 시작일 이후인지 체크
                const { data } = await this.deleteCheckGroupLesson(
                    val,
                    this.editField.lessonEndDate,
                    this.centerLessonScheduleMasterId,
                    'O'
                ); // 정산된 경우가 있는지 확인
                if (val === '' || val === undefined || val === null) {
                    return;
                }
                // if(checkAfterStartDt === false) {
                //     alert(`선택한 ${val} 이후의 예약내역은 모두 예약취소 및 삭제되며 복구가 불가합니다`)
                // }
                // 정산된 경우가 있는경우
                if (data.items.length > 0) {
                    console.log('정산내역 존재', data.items);
                    alert('이미 정산된 내역이 있어 종료일을 줄일 수 없습니다. 정산취소 후 다시 시도 해 주세요');
                    // this.editField.lessonEndDate = this.orgEndDate;
                    this.flag = false;
                    return;
                } else if (checkAfterStartDt === false) {
                    // this.flag = true;
                    alert(`선택한 ${val} 이후의 예약내역은 모두 예약취소 및 삭제되며 복구가 불가합니다`);
                }
                this.editField.lessonEndDate = val;
                this.flag = true;
                // this.onSearchList();
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        // 예약수업 취소처리
        async reserveLessonCancle(schdMstId, schdId, custId) {
            try {
                const { data } = await this.getReserveLessonCancle(schdMstId, schdId, custId);
                console.log('예약수업 취소', data);
            } catch (error) {
                console.log('error');
                console.log(error);
            }
        },
        // 예약수업 취소처리 API
        getReserveLessonCancle(schdMstId, schdId, custId) {
            return api.delete(`/admin/api/center/${this.centerId}/lesson/schedule/cancelLesson`, {
                params: {
                    scheduleMasterId: schdMstId,
                    scheduleId: schdId,
                    customerId: custId,
                    attendanceDevice: 'AW',
                    scheduleCancelReason: '', // 비필수
                    couponYn: false,
                },
            });
        },

        // 그룹레슨 삭제 기능
        async onClickBtnDeleteGroupLesson() {
            if (!confirm('이 레슨을 삭제하시겠습니까?')) {
                return;
            }
            try {
                await this.deleteGroupLesson(this.centerLessonScheduleMasterId);
                // alert('그룹레슨을 삭제하었습니다.');
                this.lessonModifyPop = false;
                await this.onSearchList(); // 조회
            } catch (error) {
                // Utils.alertResponseErrorMessge(error);
                alert('이미 예약된 내역이 있어 삭제가 불가합니다');
                console.log(error);
            }
        },
        // 그룹레슨 api 호출
        deleteGroupLesson(lessonScheduleMasterId) {
            return api.delete(`/admin/api/center/${this.centerId}/lesson/${lessonScheduleMasterId}/group`);
        },
        deleteCheckGroupLesson(startDate, endDate, masterId, billStat) {
            return api.get(`/admin/api/center/${this.centerId}/lesson/calculate/search`, {
                params: {
                    ...this.pagingInfo,
                    startDate: moment(startDate).format('YYYYMMDD'),
                    endDate: moment(endDate).format('YYYYMMDD'),
                    centerLessonScheduleMasterID: masterId,
                    billStatus: billStat,
                    sortColumn: 'lessonDate',
                    sortType: 'DESC',
                },
            });
        },
        // 수정 팝업하면 값 넘기기
        async editPopup(masterId) {
            this.isModeChangeTeacher = false;
            this.initForm(this.editField);

            try {
                this.lessonModifyPop = true;
                this.centerLessonScheduleMasterId = masterId;

                const { data } = await this.getEdit();
                this.editField.data = data;
                this.orgEndDate = data.lessonEndDate; // 원래 날짜 저장
                this.splitStartTime = data.lessonStartTime.split(':');
                this.rooms.selectedValue = data.centerRoomId;
                this.editField.lessonStaffId = data.lessonStaffId; // 강사명
                this.editField.lessonStartDate = data.lessonStartDate; // 수업기간
                this.editField.lessonEndDate = data.lessonEndDate;
                this.editField.scheduleRepeatWeek = data.scheduleRepeatWeek.split(':'); // 수업요일
                this.editField.lessonStartTime = data.lessonStartTime; // 수업시작시간
                this.editField.lessonEndTime = data.lessonEndTime; // 수업시작시간
                this.editField.lessonTotalTime = data.lessonTotalTime; // 수업 진행시간
                this.editField.lessonName = data.lessonName; // 프로그램명
                this.editField.lessonMemberMaxCount = data.lessonMemberMaxCount; // 최대인원
                this.editField.lessonMemberWaitEnableCount = data.lessonMemberWaitEnableCount; // 가능인원
                this.editField.lessonForceOffYn = data.lessonForceOffYn; // 강제휴강여부
                this.editField.lessonForceOffCondTime = data.lessonForceOffCondTime; // 강제휴강시간
                this.editField.lessonForceOffMenberCount = data.lessonForceOffMenberCount; // 강제휴강인원
                this.editField.productCategorys = []; // 카테고리 배열

                this.editField.selectedCategories = [];

                if (!Utils.isEmpty(data.categorys) && data.categorys.length > 0) {
                    for (const category of data.categorys) {
                        if (category.centerProductCategoryTemplateId != 0) {
                            this.editField.selectedCategories.push(category.centerProductCategoryTemplateId);
                        }
                    }
                }
                // 모든 카테고리가 선택되었을때 전체 항목 선택(03.30)
                if (this.editField.selectedCategories.length === this.categoryValList.length - 1) {
                    this.editField.selectedCategories.unshift('all');
                }

                this.editField.autoResvYn = data.autoResvYn ||  'N';
                this.editField.autoResvLimitHour = String(data.autoResvLimitHour || 0);
                this.editField.autoResvLimitMin = String(data.autoResvLimitMin || 0);

            } catch (error) {
                console.log(error);
            }
        },
        // 수정을 위한 조회 api
        getEdit() {
            // 스웨거 검색: 레슨 조회
            return api.get(`/admin/api/center/${this.centerId}/lesson/${this.centerLessonScheduleMasterId}`);
        },
        // 검색 조건 초기화
        resetSearchParams() {
            this.progress = '';
            this.staffValList = '';
            this.onSearchList();
            EventBus.$emit('event:initList', 'init');
        },
        // 컬럼 조회를 위한 스태프 리스트
        async fetchSearchList() {
            try {
                const { data } = await this.getSearchList(); // 스태프값 조회
                data.items.forEach((g) => {
                    this.staffSearchList.push(g.clsm_less_staff_id);
                    this.staffSearchValueList.push(g.clsm_less_staff_id);
                });
            } catch (error) {
                console.log('스태프 목록값을 가져오는데 실패했습니다.');
                console.log(error);
            }
        },
        // 초기화
        initForm(parents) {
            if (!parents) {
                parents = this;
            }

            this.selectFormStartHour.selectedValue = '00';
            this.selectFormStartMin.selectedValue = '00';
            this.selectFormLessonTime.selectedValue = 60;

            // this.rooms.selectedValue = null;

            parents.teacherStaff = ''; // 강사명 초기화
            parents.lessonName = '';
            parents.lessonMemberMaxCount = null;
            parents.lessonMemberWaitEnableCount = null;
            parents.lessonForceOffCondTime = null;
            parents.lessonForceOffMenberCount = null;
            // parents.startDate = '';
            // parents.endDate = '';
            parents.startDate = moment().format('YYYY-MM-DD');
            parents.endDate = moment().format('YYYY-MM-DD');
            for (let i = 0; i < parents.scheduleRepeatWeek.length; i += 1) {
                parents.scheduleRepeatWeek[i] = 'X';
            }

            parents.lessonForceOffYn = null;
            parents.selectedCategories = [];
        },
        // 카테고리조회
        getSearchCategory() {
            return api.get(`/admin/api/center/${this.centerId}/product/category/template`);
        },
        // 그룹레슨 등록 버튼 클릭시
        async groupLessonReg() {
            try {
                this.initForm(this);
                this.lessonForceOffYn = false;
                this.lessonPop = true;

                this.schedules = [
                    {
                        repeatWeek: ['X', 'X', 'X', 'X', 'X', 'X', 'X'],
                        startHour: '00',
                        startMin: '00',
                        lessonTime: 60,
                    },
                ];
                this.rooms.selectedValue = null;
                // 그룹레슨 등록 관련 카테고리 세팅(03.30)
                const { data } = await this.getSearchCategory();
                this.selectedCategories = ['all'];
                data.forEach((g) => {
                    this.selectedCategories.push(g.centerProductCategoryTemplateId);
                });
            } catch (error) {
                console.log(error);
            }
        },

        // 일괄수정 버튼 클릭시
        async groupLessonBatchModify() {
            if (this.checkLessonList.length === 0) {
                return;
            }

            try {
                this.initForm(this.editField);
                this.editField.selectedCategories = [];
                this.editField.changeTeacher.lessonStaffId = '';

                this.lessonModifyBatchPop = true;
            } catch (error) {
                console.error(error);
            }
        },

        updateReserveHour(hour) {
            this.splitStartTime = [hour, this.splitStartTime[1]];
        },
        updateReserveMin(min) {
            this.splitStartTime = [this.splitStartTime[0], min];
        },
        async fetchReservationSetting() {
            const { data } = await this.getCenterReservSetting();
            this.reservationSetting = data;
        },
        getCenterReservSetting() {
            return api.get(`/admin/api/center/${this.centerId}/reservation-setting`);
        },
        updateLessonTime(time) {
            this.selectFormLessonTime.selectedValue = time;
            this.editField.lessonTotalTime = time;
        },
        convertMinutes(minutes) {
            if (minutes === 30) {
                return '30분';
            } else if (minutes === 60) {
                return '1시간';
            } else if (minutes === 90) {
                return '1시간30분';
            } else if (minutes === 120) {
                return '2시간';
            } else if (minutes === 180) {
                return '3시간';
            }
        },
        async onClickBtnModify() {
            if (this.isModeChangeTeacher) {
                await this.changeLessonTeacher();
            } else if (this.flag === true) {
                await this.modifyGroupLesson();
            } else {
                alert('이미 정산된 내역이 있어 종료일을 줄일 수 없습니다. 정산취소 후 다시 시도 해 주세요.');
            }
        },

        // 그룹레슨 수정
        async modifyGroupLesson() {
            // if(this.flag == false){
            //     alert('이미 정산된 내역이 있어 종료일을 줄일 수 없습니다. 정산취소 후 다시 시도 해 주세요.')
            //     return;
            // }
            // 확인을 눌렀을때만 돌았는지 안돌았는지 체크
            if (modifyGroupLesson_flag) {
                return false;
            }

            if (
                !confirm(
                    '수정하시겠습니까?\n*그룹주간표에서 한건 씩 변경 된 수업명/예약인원은 변경되지 않습니다.(강사변경 시 제외)'
                )
            ) {
                return;
            }
            // 확인을 눌렀을때만 돌았는지 안돌았는지 체크
            if (modifyGroupLesson_flag) {
                return false;
            }
            modifyGroupLesson_flag = true;

            try {
                const params = this.getEditParams();
                if (!params.scheduleRepeatWeek.includes('O')) {
                    alert('수업요일을 확인해주세요.');
                    return;
                }
                const result = await this.putEditGroupLesson(params);
                // // 날짜가 수정되면 수정이후의 예약 취소
                if (this.changeDate === this.orgEndDate) {
                    // 수정안됨.
                } else {
                    // 백엔드 로직에서 기간을 변경 할 경우 이미 이전의 수강스케줄 및 예약을 취소하는 로직이 존재한다.
                    // 추후 문제가 있을 경우 다시 살리자.
                    // 20220917윤종선
                    // const {data} = await this.deleteCheckGroupLesson(this.changeDate, this.orgEndDate, this.centerLessonScheduleMasterId);
                    // console.log('수정예약을 취소를 위한', data);
                    // //
                    // for (const g of data.items) {
                    //   if (g.clsc_bill_status_cd !== 'O') {
                    //     // const editDate = await this.reserveLessonCancle(g.cls_center_less_schd_master_id, g.cls_center_less_schd_id, g.clsc_center_cust_id);
                    //     console.log('수정결과 확인'.editDate);
                    //   }else {
                    //     alert('이미 정산된 내역이 있어 종료일을 줄일 수 없습니다. 정산취소 후 다시 시도 해 주세요');
                    //     break;
                    //   }
                    // }
                }
                this.lessonModifyPop = false;
                await this.onSearchList(); // 조회
                modifyGroupLesson_flag = false;
            } catch (error) {
                this.lessonModifyPop = false;
                modifyGroupLesson_flag = false;

                Utils.alertResponseErrorMessge(error);
                console.log(error);
            }
        },

        // 일괄 수정
        handleBatchUpdate() {
            if (this.editField.changeTeacher.lessonStaffId) {
                this.updateBatchWithStaff();
            } else {
                this.updateBatch();
            }
        },

        // 일괄 수정 (강사)
        async updateBatchWithStaff() {
            if (!confirm('수정하시겠습니까?\n*강사 변경 시 한 건씩 변경하신 수업도 모두 기본 옵션으로 재 설정 됩니다.')) {
                return;
            }

            const today = moment();

            for (let i = 0; i < this.checkLessonList.length; i += 1) {
                const lesson = this.groupLessonList.find(
                    (l) => l.clsm_center_less_schd_master_id === this.checkLessonList[i]
                );
                if (!lesson) continue;

                let prevLessonEndDate = today.isAfter(lesson.clsm_less_start_dt) ? today : moment(lesson.clsm_less_start_dt);
                let lessonStartDate = today.isAfter(lesson.clsm_less_start_dt)
                    ? moment(prevLessonEndDate).add(1, 'days')
                    : prevLessonEndDate;
                const newLesson = {
                    lessonStaffId: this.editField.changeTeacher.lessonStaffId,
                    lessonStartDate: lessonStartDate.format('YYYYMMDD'),
                    lessonEndDate: lesson.clsm_less_end_dt.substring(0, 10).replace(/-/g, ''),
                    scheduleRepeatWeek: lesson.clsm_schd_rep_week,
                    lessonStartTime: lesson.clsm_less_start_tm.substring(0, 8),
                    lessonEndTime: lesson.clsm_less_end_tm.substring(0, 8),
                    lessonTotalTime: lesson.clsm_less_total_tm,
                    lessonName: this.editField.lessonName || lesson.clsm_less_nm,
                    lessonMemberMaxCount:
                        this.editField.lessonMemberMaxCount === null
                            ? lesson.clsm_less_mem_max_cnt
                            : this.editField.lessonMemberMaxCount,
                    lessonMemberWaitEnableCount:
                        this.editField.lessonMemberWaitEnableCount === null
                            ? lesson.clsm_less_mem_wait_enable_cnt
                            : this.editField.lessonMemberWaitEnableCount,
                    lessonForceOffYn:
                        this.editField.lessonForceOffYn === null
                            ? lesson.clsm_less_forc_off_yn
                            : this.editField.lessonForceOffYn,
                    lessonForceOffCondTime:
                        this.editField.lessonForceOffCondTime === null
                            ? lesson.clsm_less_forc_off_cond_time
                            : this.editField.lessonForceOffCondTime,
                    lessonForceOffMenberCount:
                        this.editField.lessonForceOffMenberCount === null
                            ? lesson.clsm_less_forc_off_mem_cnt
                            : this.editField.lessonForceOffMenberCount,
                    productCategorys: this.editField.selectedCategories.length
                        ? this.getProductCategoriesWithSelected(this.editField.selectedCategories)
                        : null,
                    centerRoomId: lesson.clsm_center_room_id,
                    roomPickYn: !!lesson.clsm_center_room_id,
                };

                const params = {
                    prevLessonEndDate: prevLessonEndDate.format('YYYYMMDD'),
                    newLesson,
                };

                try {
                    await this.getStaffChange(params, lesson.clsm_center_less_schd_master_id);
                } catch (error) {
                    if (error.response.data) alert(error.response.data.message);
                    return;
                }

                if (lessonStartDate.isSame(prevLessonEndDate, 'day')) {
                    await this.deleteGroupLesson(lesson.clsm_center_less_schd_master_id);
                }
            }

            this.onSearchList(); // 조회

            this.closeBatchModifyPopup();
            this.checkLessonList = [];
        },

        // 일괄 수정
        async updateBatch() {
            if (!confirm('수정하시겠습니까?\n*그룹주간표에서 한건 씩 변경 된 수업명/예약인원은 변경되지 않습니다.(강사변경 시 제외)')) {
                return;
            }

            for (let i = 0; i < this.checkLessonList.length; i += 1) {
                const lesson = this.groupLessonList.find(
                    (l) => l.clsm_center_less_schd_master_id === this.checkLessonList[i]
                );
                if (!lesson) continue;

                const params = {
                    lessonStaffId: lesson.clsm_less_staff_id,
                    lessonStartDate: lesson.clsm_less_start_dt.substring(0, 10).replace(/-/g, ''),
                    lessonEndDate: lesson.clsm_less_end_dt.substring(0, 10).replace(/-/g, ''),
                    scheduleRepeatWeek: lesson.clsm_schd_rep_week,
                    lessonStartTime: lesson.clsm_less_start_tm.substring(0, 8),
                    lessonEndTime: lesson.clsm_less_end_tm.substring(0, 8),
                    lessonTotalTime: lesson.clsm_less_total_tm,
                    lessonName: this.editField.lessonName || lesson.clsm_less_nm,
                    lessonMemberMaxCount:
                        this.editField.lessonMemberMaxCount === null
                            ? lesson.clsm_less_mem_max_cnt
                            : this.editField.lessonMemberMaxCount,
                    lessonMemberWaitEnableCount:
                        this.editField.lessonMemberWaitEnableCount === null
                            ? lesson.clsm_less_mem_wait_enable_cnt
                            : this.editField.lessonMemberWaitEnableCount,
                    lessonForceOffYn:
                        this.editField.lessonForceOffYn === null
                            ? lesson.clsm_less_forc_off_yn
                            : this.editField.lessonForceOffYn,
                    lessonForceOffCondTime:
                        this.editField.lessonForceOffCondTime === null
                            ? lesson.clsm_less_forc_off_cond_time
                            : this.editField.lessonForceOffCondTime,
                    lessonForceOffMenberCount:
                        this.editField.lessonForceOffMenberCount === null
                            ? lesson.clsm_less_forc_off_mem_cnt
                            : this.editField.lessonForceOffMenberCount,
                    productCategorys: this.editField.selectedCategories.length
                        ? this.getProductCategoriesWithSelected(this.editField.selectedCategories)
                        : null,
                    centerRoomId: lesson.clsm_center_room_id,
                    roomPickYn: !!lesson.clsm_center_room_id,
                };

                try {
                    await this.putEditGroupLesson(params, lesson.clsm_center_less_schd_master_id);
                } catch (error) {
                    if (error.response.data) alert(error.response.data.message);
                    return;
                }
            }

            this.onSearchList(); // 조회

            this.closeBatchModifyPopup();
            this.checkLessonList = [];
        },

        /*
    onChangeCategory(v){
        this.editField.selectedCategories = v;
    }, */
        getProductCategoriesWithSelected(selectedCategories) {
            const res = [];

            selectedCategories.forEach((categoryId) => {
                if (categoryId === 'all') return;

                const idx = this.categoryList.indexOf(categoryId.toString());
                const categoryName = idx !== -1 ? this.categoryValList[idx] : '';

                res.push({
                    centerProductCategoryTemplateId: parseInt(categoryId, 10),
                    centerProductCategoryTemplateName: categoryName,
                });
            });

            return res;
        },
        getEditParams() {
            this.editField.productCategorys = this.getProductCategoriesWithSelected(this.editField.selectedCategories);
            const tmFormat = 'HH:mm:ss';
            const dtFormat = 'YYYY-MM-DD HH:mm:ss';
            const startTime = `${this.splitStartTime[0]}:${this.splitStartTime[1]}:00`;

            const lessonStartDatetime = `${this.editField.lessonStartDate} ${startTime}`;

            const endTime = moment(lessonStartDatetime, dtFormat)
                .add(this.editField.lessonTotalTime, 'minutes')
                .format(tmFormat);
            return {
                lessonStaffId: this.editField.lessonStaffId,
                lessonStartDate: moment(this.editField.lessonStartDate).format('YYYYMMDD'),
                lessonEndDate: moment(this.editField.lessonEndDate).format('YYYYMMDD'),
                scheduleRepeatWeek: this.editField.scheduleRepeatWeek.join(':'),
                lessonStartTime: `${startTime}`,
                lessonEndTime: `${endTime}`,
                lessonTotalTime: this.editField.lessonTotalTime,
                lessonName: this.editField.lessonName,
                lessonMemberMaxCount: this.editField.lessonMemberMaxCount,
                lessonMemberWaitEnableCount: this.editField.lessonMemberWaitEnableCount,
                lessonForceOffYn: this.editField.lessonForceOffYn,
                lessonForceOffCondTime: this.editField.lessonForceOffCondTime,
                lessonForceOffMenberCount: this.editField.lessonForceOffMenberCount,
                productCategorys: this.editField.productCategorys,
                centerRoomId: this.rooms.selectedValue,
                roomPickYn: !!this.rooms.selectedValue,
                autoResvYn : this.editField.autoResvYn,
                autoResvLimitHour : this.editField.autoResvLimitHour,
                autoResvLimitMin : this.editField.autoResvLimitMin,
            };
        },
        // 그룹레슨 수정
        putEditGroupLesson(params, id) {
            const schdId = id || this.centerLessonScheduleMasterId;
            return api.put(`/admin/api/center/${this.centerId}/lesson/${schdId}/group`, params);
        },
        // 강사변경 기능
        async changeLessonTeacher() {
            try {
                const { prevEndDate, nextStartDate, nextEndDate, lessonStaffId } = this.editField.changeTeacher;

                if (Utils.isEmpty(lessonStaffId)) {
                    alert('변경할 강사를 선택해주세요.');
                    return;
                }
                if (moment(nextStartDate).isAfter(nextEndDate)) {
                    alert('변경 후 시작일이 종료일 이후입니다.');
                    return;
                }

                if (
                    !confirm(
                        '강사를 변경하시겠습니까?\n*강사 변경 시 한 건씩 변경하신 수업도 모두 기본 옵션으로 재 설정 됩니다.'
                    )
                ) {
                    return;
                }

                const postDateFormat = 'YYYYMMDD';
                const newLesson = this.getEditParams();
                const prevLessonEndDate = moment(prevEndDate).format(postDateFormat);
                newLesson.lessonStartDate = moment(nextStartDate).format(postDateFormat);
                newLesson.lessonEndDate = moment(nextEndDate).format(postDateFormat);
                newLesson.lessonStaffId = lessonStaffId;

                const params = {
                    prevLessonEndDate,
                    newLesson,
                };

                await this.getStaffChange(params);

                this.lessonModifyPop = false;
                await this.onSearchList();
            } catch (error) {
                Utils.alertResponseErrorMessge(error);
            }
        },
        // 그룹레슨 강사수정
        getStaffChange(params, id) {
            const schdId = id || this.centerLessonScheduleMasterId;
            return api.put(`/admin/api/center/${this.centerId}/lesson/${schdId}/group/changeTeacher`, params);
        },
        updateNextEndDate(val) {
            // this.editStaff.lessonEndDate = val;
            this.editField.changeTeacher.nextEndDate = val;
        },
        // 강사변경에서 날짜를 변경했을때
        updatePrevEndDate(val) {
            const { editField } = this;
            const { changeTeacher } = editField;

            changeTeacher.prevEndDate = val;
            changeTeacher.nextStartDate = moment(val).add(1, 'days').format('YYYY-MM-DD');
        },
        async onClickBtnShowChangeTeacher() {
            const today = moment();
            const tomorrow = moment(today).add(1, 'days');

            const { editField } = this;

            const check = await this.deleteCheckGroupLesson(
                this.editField.lessonStartDate,
                this.editField.lessonEndDate,
                this.centerLessonScheduleMasterId,
                'O'
            );
            if (check.data.items.length === 0) {
            } else if (moment(today).isAfter(check.data.items[0].cls_less_dt)) {
                // 오늘 날이 최근 정산기록(수업일자) 보다 이후일 경우.
                // 통과.
            } else {
                // 오늘 날이 최근 정산기록(수업일자) 보다 이전일 경우.
                for (let i = 0; i < check.data.items.length; i += 1) {
                    if (
                        check.data.items[i].clsc_atnd_status_cd === '-' &&
                        check.data.items[i].clsc_resv_status_cd !== 'RW'
                    ) {
                    } else {
                        alert('정산완료 된 수업이 있습니다. 정산을 취소 후 강사 변경을 해주세요.');
                        return false;
                    }
                }
            }

            // if (moment(editField.data.lessonStartDate)
            //     .isAfter(today)) {
            //     alert('시작하지 않은 강의는 강사변경을 할 수 없습니다.');
            //     return false;
            // }

            this.isModeChangeTeacher = true;

            const { changeTeacher } = editField;

            changeTeacher.prevStartDate = editField.data.lessonStartDate;
            changeTeacher.prevEndDate = today.isAfter(editField.data.lessonStartDate) ? today.format('YYYY-MM-DD') : editField.data.lessonStartDate;

            changeTeacher.nextStartDate = moment(editField.data.lessonEndDate).isAfter(changeTeacher.prevEndDate)
                ? moment(changeTeacher.prevEndDate).add(1, 'days').format('YYYY-MM-DD')
                : moment(changeTeacher.prevEndDate).format('YYYY-MM-DD');
            changeTeacher.nextEndDate = editField.data.lessonEndDate;
        },
        onClickBtnCancelModify() {
            const { editField } = this;

            if (editField.mode === 'change') {
                editField.mode = 'modify';
            } else {
                this.lessonModifyPop = false;
            }
        },
        updateNextTeacher(val) {
            console.log('updateNextTeacher', val);
            this.editField.changeTeacher.lessonStaffId = val;
        },
        onClickBtnCloseModify() {
            this.lessonModifyPop = false;
            this.isModeChangeTeacher = false;
        },
        closeBatchModifyPopup() {
            this.lessonModifyBatchPop = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.layer-pop .com-table .com-btn {
    height: 32px;
}
</style>
